var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"store-skeleton"},[_c('skeleton',{attrs:{"type":"rect","width":'100%',"height":'200px',"circle":false}}),_c('skeleton',{attrs:{"type":"rect","width":'100%',"height":'50px'}}),_c('skeleton-filter-with-item')],1)}
var staticRenderFns = []

export { render, staticRenderFns }